import { Dic } from "$utils";
export const tableOption = function (that) {
  return {
    add: "新增设备",
    edit: "修改设备",
    view: "设备详情",
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "left",
    menuAlign: "center",
    labelSuffix: "：",
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: "120px",
    dialogWidth: "700px",
    column: [
      {
        label: "设备名称",
        prop: "deviceName",
        overHidden: true,
        search: true,
        addDisplay: true,
        editDisplay: true,
        span: 24,
        viewDisplay: true,
        editDisabled: false,
        rules: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: ["change", "blur"]
          }
        ]
      },
      // 关联通行记录展示轨迹
      {
        label: "通道名称",
        prop: "channelName",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        span: 24,
        viewDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入通道名称",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "主设备类型",
        prop: "deviceTypeName",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        span: 12,
        viewDisplay: true
      },
      {
        label: "厂商",
        prop: "factoryName",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        span: 12,
        viewDisplay: true
      },
      {
        label: "第三方设备ID",
        prop: "thirdDeviceId",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        editDisabled: true,
        span: 12,
        viewDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入第三方设备ID",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "设备状态",
        prop: "status",
        search: true,
        overHidden: true,
        addDisplay: true,
        span: 12,
        viewDisplay: true,
        type: "select",
        dicData: [
          {
            label: "故障",
            value: "2"
          },
          {
            label: "在线",
            value: "1"
          },
          {
            label: "离线",
            value: "0"
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1
            ? "在线"
            : Number(value) === 2
            ? "故障"
            : "离线";
        },
        viewFormatter: (row, value) => {
          return Number(value) === 1
            ? "在线"
            : Number(value) === 2
            ? "故障"
            : "离线";
        },
        rules: [
          {
            required: true,
            message: "请选择设备状态",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "IP",
        prop: "deviceHost",
        overHidden: true,
        span: 12,
        addDisplay: true,
        viewDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入IP",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "端口",
        prop: "devicePort",
        overHidden: true,
        span: 12,
        addDisplay: true,
        viewDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入端口",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "用户名",
        prop: "userName",
        hide: true,
        overHidden: true,
        span: 12,
        addDisplay: true,
        viewDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入用户名",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "密码",
        prop: "password",
        hide: true,
        overHidden: true,
        span: 12,
        type: "password",
        showPassword:true,
        addDisplay: true,
        viewDisplay: false,
        rules: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["change", "blur"]
          }
        ]
      },

      {
        label: "设备描述",
        prop: "thirdDeviceDesc",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        type: "textarea",
        minRows: 3,
        maxlength: 200
      }
    ]
  };
};
